import { twMerge } from 'tailwind-merge';
import React, { ReactNode } from 'react';
import IconBadge from './IconBadge';

interface Props {
    children: ReactNode;
    value: string | boolean;
    onClick: (value: string | boolean) => void;
    selected?: string | boolean;
    description?: ReactNode;
    isDisabled?: boolean;
}

const SettingSelectableItem = ({
    children,
    value,
    onClick,
    selected,
    description,
    isDisabled,
}: Props) => {
    const isSelected = selected === value;

    return (
        <div
            onClick={() => (!isSelected || isDisabled ? onClick(value) : null)}
            className={twMerge(
                'flex h-13 w-full items-center justify-between rounded-sm px-2',
                !isSelected ? 'cursor-pointer hover:bg-gray-100' : null,
                isDisabled ? 'cursor-not-allowed bg-gray-100' : null,
            )}
        >
            <div className="flex flex-col">
                {children}
                <div>
                    {description ? (
                        <div className="mt-2 text-xs text-gray-500">
                            {description}
                        </div>
                    ) : null}
                </div>
            </div>

            {isSelected ? (
                <IconBadge iconKey="done" size="1rem" className="p-1" />
            ) : null}
        </div>
    );
};

export default SettingSelectableItem;
